export default "__VITE_ASSET__CZi$H8tY__"